// extracted by mini-css-extract-plugin
export var adjacentSlide = "_pj-9";
export var arrowButtonContainer = "_pj-5";
export var arrowButtonIcon = "_pj-6";
export var carouselArrowButton = "_pj-2";
export var carouselElementContainer = "_pj-1";
export var currentSlide = "_pj-8";
export var left = "_pj-3";
export var otherSlide = "_pj-a";
export var productCarouselContainer = "_pj-0";
export var right = "_pj-4";
export var sliderOverflow = "_pj-7";